import { useState, useEffect, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const SCROLL_TARGETS = {
  about: 1042,
  why: 2042,
  contact: 3100,
};

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [theme, setTheme] = useState(
    localStorage.getItem("theme") ? localStorage.getItem("theme") : "light"
  );

  useEffect(() => {
    localStorage.setItem("theme", theme);
    document.querySelector("html").setAttribute("data-theme", theme);
  }, [theme]);

  // Scroll on the home page; if elsewhere, navigate home first then scroll once it mounts.
  const goToSection = useCallback((key) => () => {
    const top = SCROLL_TARGETS[key];
    if (location.pathname === "/") {
      window.scrollTo({ top, behavior: "smooth" });
    } else {
      navigate("/", { state: { scrollTo: top } });
    }
  }, [location.pathname, navigate]);

  // After cross-route navigation, honor the deferred scroll position.
  useEffect(() => {
    const top = location.state?.scrollTo;
    if (location.pathname === "/" && typeof top === "number") {
      // Wait a frame for the page to mount
      requestAnimationFrame(() => window.scrollTo({ top, behavior: "smooth" }));
    }
  }, [location]);

  return (
    <div className="navbar bg-base-100">
      <div className="navbar-start">
        <div className="dropdown">
          <label tabIndex={0} className="btn btn-ghost lg:hidden">
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" />
            </svg>
          </label>
          <ul tabIndex={0} className="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52">
            <li><button type="button" onClick={goToSection("about")}>About</button></li>
            <li><button type="button" onClick={goToSection("why")}>Why Us</button></li>
            <li><button type="button" onClick={goToSection("contact")}>Contact Us</button></li>
          </ul>
        </div>
        <Link to="/" className="btn btn-ghost normal-case text-2xl">Pinaki Infotech</Link>
      </div>
      <div className="navbar-center hidden lg:flex">
        <ul className="menu menu-horizontal px-1">
          <li><button type="button" onClick={goToSection("about")}>About</button></li>
          <li><button type="button" onClick={goToSection("why")}>Why Us</button></li>
          <li tabIndex={0}>
            <details>
              <summary>Rental</summary>
              <ul className="p-2">
                <li><button type="button">Industry Standard Laptops</button></li>
                <li><button type="button">Graphic Rentals</button></li>
                <li><button type="button">Executive Laptops</button></li>
              </ul>
            </details>
          </li>
          <li><button type="button" onClick={goToSection("contact")}>Contact Us</button></li>
        </ul>
      </div>
      <div className="navbar-end">
        <Link to="/" className="btn btn-ghost" aria-label="Home">
          <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l9-9 9 9M5 10v10h14V10" />
          </svg>
        </Link>
      </div>
    </div>
  );
};
export default Navbar;
